import { CustomFeesWrapper } from "../../components";

export default function CustomFeesPage() {
  return <CustomFeesWrapper />;
}
